import React from 'react';
import { Switch, Route } from 'react-router-dom';
import AvitaillementList from './avitaillement-list';
import AvitaillementForms from './avitaillement-forms';
import { paths } from '../../../routes';

const Asct = () => (
  <Switch>
    <Route path={paths.newAvitaillement.path}>
      <AvitaillementForms />
    </Route>
    <Route path={paths.avitaillement.path + '/:reportId'}>
      <AvitaillementForms />
    </Route>
    <Route path={paths.avitaillement.path}>
      <AvitaillementList />
    </Route>
  </Switch>
);

export default Asct;